import {
  DISPLAY_NAVIGATION,
  HIDE_NAVIGATION,
  SET_LANGUAGE
} from '@flow/store/navigation/constants';

export function show() {
  return {
    type: DISPLAY_NAVIGATION,
    visible: true,
  }
}

export function hide() {
  return {
    type: HIDE_NAVIGATION,
    visible: false,
  }
}

export function setLanguage(appLanguage: IAppLanguage, lang_versions: LangVersions) {
  return {
    type: SET_LANGUAGE,
    appLanguage,
    lang_versions,
  }
}


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/navigation/actions.ts